import { useState } from "react";
import type { StepDetailProps } from "./index";
import { STEP_OUTPUT_SCHEMAS, zodIssuesToErrors } from "./schemas";
import { StepActions } from "./StepActions";

export function WaitDetail({
  step,
  play,
  workspaceId,
  currentUserId,
  persona,
}: StepDetailProps) {
  const until =
    typeof step.inputs["until"] === "string"
      ? (step.inputs["until"] as string)
      : "—";
  const [reason, setReason] = useState<string>("");
  const [errors, setErrors] = useState<Record<string, string>>({});

  const buildOutput = (): Record<string, unknown> | null => {
    const payload = {
      woke_at: new Date().toISOString(),
      reason,
    };
    const parsed = STEP_OUTPUT_SCHEMAS["wait"].safeParse(payload);
    if (!parsed.success) {
      const map: Record<string, string> = {};
      for (const e of zodIssuesToErrors(parsed.error)) map[e.path] = e.message;
      setErrors(map);
      return null;
    }
    setErrors({});
    return parsed.data as Record<string, unknown>;
  };

  return (
    <div className="ho-detail ho-quiet" data-testid="step-detail-wait">
      <div className="ho-eb">WAIT · AUTONOMOUS</div>
      <h2 className="ho-h2">{step.title}</h2>
      <div className="ho-meta-row">
        <span className="pill">until: {until}</span>
        {step.state === "running" || step.state === "ready" ? (
          <span className="pill green">● waiting</span>
        ) : null}
      </div>
      <div className="ho-quiet-b">
        <div className="ho-quiet-h">NOTHING NEEDED FROM YOU</div>
        <div className="ho-quiet-s">
          The play will advance automatically when the upstream signal lands.
          You can mark this wait as resolved manually below if you have
          confirmation already.
        </div>
      </div>

      {step.state === "running" ? (
        <div style={{ display: "grid", gap: 8, marginTop: 12 }}>
          <label>
            <span
              style={{
                fontSize: 11.5,
                color: "var(--text-3)",
                letterSpacing: ".14em",
              }}
            >
              REASON FOR WAKE
            </span>
            <input
              type="text"
              data-testid="wait-reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              style={{
                marginTop: 4,
                width: "100%",
                border: "1px solid var(--border)",
                borderRadius: 6,
                padding: 8,
              }}
            />
          </label>
          {errors["reason"] ? (
            <span
              style={{ color: "var(--danger)", fontSize: 12 }}
              data-testid="wait-error-reason"
            >
              {errors["reason"]}
            </span>
          ) : null}
        </div>
      ) : null}

      <StepActions
        step={step}
        workspaceId={workspaceId}
        playId={play.id}
        campaignId={play.campaignId ?? null}        currentUserId={currentUserId}
        persona={persona}
        buildOutput={buildOutput}
      />
    </div>
  );
}
